<template>
<div style="display:flex">

    <v-combobox v-model="rangeText" :items="commonRanges.map(o => o.text)" :label="label" xxxappend-outer-icon="event" style="flex-grow:1" />

    <div style="padding: 18px 0 0 5px">
        <v-icon  @click="showCalendar">event</v-icon>
    </div>

    <v-dialog v-model="dialogVisible" max-width="290">
        <div class="white-background" @click="closeIfApplicable">
            <div class="pa-3 primary white--text">
                {{dialogTitle}}
            </div>
            <v-date-picker v-if="dialogVisible" range v-model="pickerDates" no-title locale="en-AU" />
        </div>
    </v-dialog>
</div>
</template>

<script>
import DataHelpers from '../helpers/DataHelpers'
import LookupData from '../helpers/LookupData'
import DateHelpers from '../helpers/DateHelpers'
import { getYear, endOfMonth, startOfMonth, subMonths, isSameDay, format, subYears, subQuarters, startOfQuarter, lastDayOfQuarter } from 'date-fns'

export default {
    data() {
        return {
            dates: [],
            start: null,
            end: null,
            dialogVisible: false,
        }
    },

    components: {

    },

    props: {
        label: {
            type: String,
            default: 'Date Range'
        },
        value: {
            type: Object,
            default: function() {
                return {
                    start: null,
                    end: null,
                }
            }
        },
    },

    computed: {
        dialogTitle() {
            if(this.value.start && this.value.end)
                return 'From ' + format(this.value.start, 'dd/MM/yy') + ' to ' + format(this.value.end, 'dd/MM/yy')
            else if(this.value.start && !this.value.end)
                return format(this.value.start, 'dd/MM/yy') + '. Select another...'
            else
                return 'Select 2 dates...'
        },

        commonRanges() {
            const thisYear = getYear(new Date())
            const ranges = []
            const today = new Date()

            const lastQuarterStartDate = startOfQuarter(subQuarters(today,1))
            const lastQuarterEndDate = lastDayOfQuarter(subQuarters(today,1))
            const thisQuarterStartDate = startOfQuarter(today)
            const thisQuarterEndDate = lastDayOfQuarter(today)

            // console.log('lastQuarterStartDate', lastQuarterStartDate)
            // console.log('lastQuarterEndDate', lastQuarterEndDate)
            // console.log('thisQuarterStartDate', thisQuarterStartDate)
            // console.log('thisQuarterEndDate', thisQuarterEndDate)


            let start = startOfMonth(today)
            let end = endOfMonth(today)
            let text = 'This Month'
            ranges.push({text, start, end})

            const aMonthAgo = subMonths(today, 1)
            start = startOfMonth(aMonthAgo)
            end = endOfMonth(aMonthAgo)
            text = 'Last Month'
            ranges.push({text, start, end})

            ranges.push({
                text: 'This Quarter',
                start: thisQuarterStartDate,
                end: thisQuarterEndDate
            })

            ranges.push({
                text: 'Last Quarter',
                start: lastQuarterStartDate,
                end: lastQuarterEndDate
            })

            for(let i = 2; i < 12; i++) {
                const dt = subMonths(new Date(), i)
                const start = startOfMonth(dt)
                const end = endOfMonth(dt)
                const text = format(dt, 'MMMM')
                const range = {
                    text, start, end
                }
                ranges.push(range)
            }

            start = subMonths(today, 3)
            end = today
            text = 'Past 3 Months'
            ranges.push({text, start, end})

            start = subMonths(today, 6)
            end = today
            text = 'Past 6 Months'
            ranges.push({text, start, end})

            start = subYears(today, 1)
            end = today
            text = 'Past Year'
            ranges.push({text, start, end})

            return ranges
        },

        pickerDates: {
            get() {
                let range = []
                if(this.value.start) {
                    range.push(DateHelpers.dateToBackwards(this.value.start))
                    if(this.value.end)
                        range.push(DateHelpers.dateToBackwards(this.value.end))
                }
                return range
            },
            set(val) {

                if(!val || !val.length) {
                    this.value.start == null
                    this.value.end == null
                    return
                }
                const sortedRange = val.sort()
                if(sortedRange.length == 1) {
                    this.value.start = DateHelpers.backwardsToDate(sortedRange[0])
                    this.value.end = null
                    return
                }
                this.value.start = DateHelpers.backwardsToDate(sortedRange[0])
                this.value.end = DateHelpers.backwardsToDate(sortedRange[1])
            }
        },
        rangeText: {
            get() {

                if(!this.value.start)
                    return ''

                if(this.value.start && !this.value.end) {
                    const dtString = DateHelpers.dateToAu(this.value.start)
                    return dtString + ' - ' + dtString
                }

                //look up common ranges
                const foundRange = this.commonRanges.find(o => (isSameDay(this.value.start, o.start) && isSameDay(this.value.end, o.end)) )
                if(foundRange)
                    return foundRange.text

                if(this.value.start && this.value.end) {
                    const startString = DateHelpers.dateToAu(this.value.start)
                    const endString = DateHelpers.dateToAu(this.value.end)
                    return startString + ' - ' + endString
                }

            },
            set(val) {
                console.log('setting range text ', val)
                if(!val) {
                    this.value.start = null
                    this.value.end = null
                    return
                }


                const foundRange = this.commonRanges.find(o => o.text == val)
                if(foundRange) {
                    this.value.start = foundRange.start
                    this.value.end = foundRange.end
                    return
                }

                const arr = val.split(' - ')
                if(arr && arr.length == 2) {
                    this.value.start = DateHelpers.toDate(arr[0])
                    this.value.end = DateHelpers.toDate(arr[1])
                }
            }
        },

        ranges() {
            return [...this.commonRanges, ...LookupData.months ].sort()
        }
    },

    methods: {
        showCalendar() {
            console.log('calendar!!')
            this.dialogVisible = true
        },
        closeIfApplicable() {
            if(this.value.end)
                this.dialogVisible = false
        }
    },

    created() {

    }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// DateRange.vue?6bb83ce3